import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FAQ_ITEMS } from "./constants";

const FaqItem = ({ item, index, open, onToggle }) => (
  <div className="border-b border-[#1A2535]/15">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      data-testid={`faq-trigger-${index}`}
      className="w-full flex items-start justify-between gap-6 py-7 text-left group focus:outline-none"
    >
      <span className="font-serif text-xl sm:text-2xl leading-snug text-[#1A2535] group-hover:text-[#B8541E] transition-colors duration-300">
        {item.q}
      </span>
      <span
        aria-hidden="true"
        className={`mt-1 shrink-0 text-2xl font-serif leading-none text-[#C9A84C] transition-transform duration-500 ${
          open ? "rotate-45" : "rotate-0"
        }`}
      >
        +
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          key="content"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="overflow-hidden"
          data-testid={`faq-content-${index}`}
        >
          <div className="pb-8 pr-6 sm:pr-10 space-y-4 text-[#1A2535]/80 font-sans font-light text-base sm:text-lg leading-relaxed">
            {item.a.split("\n\n").map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <div className="mt-4" data-testid="faq-list">
      {FAQ_ITEMS.map((item, i) => (
        <FaqItem
          key={i}
          item={item}
          index={i}
          open={openIndex === i}
          onToggle={() => setOpenIndex(openIndex === i ? null : i)}
        />
      ))}
    </div>
  );
};
